import { getMyPresenceStatus, setPresenceStatus } from "./presenceService";

// Module-level singleton so every usePresence() consumer (navbar picker,
// confirmation modal, etc.) reads/writes the same state instead of each
// holding its own stale copy after one of them calls updateStatus.
let state = { status: null, needsConfirmation: false, loading: true };
let started = false;
const listeners = new Set();

const setState = (partial) => {
    state = { ...state, ...partial };
    listeners.forEach((listener) => listener());
};

export const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

export const getSnapshot = () => state;

export const start = () => {
    if (started) return;
    started = true;
    refresh();
};

export const refresh = async () => {
    try {
        const { data } = await getMyPresenceStatus();
        setState({
            status: data?.status ?? null,
            needsConfirmation: data?.needsConfirmation ?? false,
            loading: false,
        });
    } catch (err) {
        console.error("[usePresence] failed to load status", err);
        setState({ loading: false });
    }
};

let updateRequestId = 0;

export const updateStatus = async (newStatus) => {
    const myRequestId = ++updateRequestId;
    try {
        await setPresenceStatus(newStatus);
        // Ignore a stale response - a newer call already updated state.
        if (myRequestId === updateRequestId) {
            setState({ status: newStatus, needsConfirmation: false });
        }
    } catch (err) {
        console.error("[usePresence] failed to update status", err);
    }
};
